import services_transaction from '../views/services_transaction/index.vue'
import services_transaction_create from '../views/services_transaction/create.vue'
import services_transaction_board from '../views/services_transaction/board.vue'
import services_transaction_create_old from '../views/services_transaction/create_old.vue'
import services_transaction_detail from '../views/services_transaction/detail.vue'
import services_transaction_detail_old from '../views/services_transaction/detail_old.vue'
import services_transaction_invoice_old from '../views/services_transaction/invoice_old.vue'
import services_transaction_invoice from '../views/services_transaction/invoice.vue'
import services_transaction_laba from '../views/services_transaction/labarugi.vue'

const routes = [
  {
    path: "/services_transaction",
    name: "services_transaction",
    component: services_transaction,
    meta: { authOnly: true },
  },
  {
    path: "/services_transaction/create",
    name: "services_transaction_create",
    component: services_transaction_create,
    meta: { authOnly: true },
  },
  {
    path: "/services_transaction/board",
    name: "services_transaction_board",
    component: services_transaction_board,
    meta: { authOnly: true },
  },
  {
    path: "/services_transaction/laba",
    name: "services_transaction_laba",
    component: services_transaction_laba,
    meta: { authOnly: true },
  },
  {
    path: "/services_transaction/create_old",
    name: "services_transaction_create_old",
    component: services_transaction_create_old,
    meta: { authOnly: true },
  },
  {
    path: "/services_transaction/detail/:uuid",
    name: "services_transaction_detail",
    component: services_transaction_detail,
    meta: { authOnly: true },
  },
  {
    path: "/services_transaction/detail_old/:uuid",
    name: "services_transaction_detail_old",
    component: services_transaction_detail_old,
    meta: { authOnly: true },
  },
  {
    path: "/services_transaction/invoice/:uuid",
    name: "services_transaction_invoice",
    component: services_transaction_invoice,
    meta: { authOnly: true },
  },
  {
    path: "/services_transaction/invoice_old/:uuid",
    name: "services_transaction_invoice_old",
    component: services_transaction_invoice_old,
    meta: { authOnly: true },
  }]

export default routes
